import React from "react";
import { Box, IconButton, TextField, Typography } from "@mui/material";
import {
  EmojiPickerPanel,
  SegmentMeter,
  SegmentCalculation,
} from "@tiny/sms/src/widgets";

export interface MessageEditorPanelProps {
  body: string;
  onBodyChange: (value: string) => void;
  calculation?: SegmentCalculation;
  calculationLoading?: boolean;
  senderNumber?: string;
}

function MessageEditorPanel(props: MessageEditorPanelProps) {
  const { body, onBodyChange, calculation, calculationLoading, senderNumber } =
    props;
  const [emojiOpen, setEmojiOpen] = React.useState(false);

  const handleEmojiClick = (emoji: string) => {
    onBodyChange(`${body}${emoji}`);
  };

  return (
    <Box>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography variant="h4" fontWeight="bold" color="grey" m={0}>
          Message content
        </Typography>
        <IconButton
          size="small"
          onClick={() => setEmojiOpen((prev) => !prev)}
          aria-label="Toggle emoji picker"
        >
          <span role="img" aria-hidden="true" style={{ fontSize: 18 }}>
            😊
          </span>
        </IconButton>
      </Box>

      {emojiOpen && <EmojiPickerPanel onEmojiClick={handleEmojiClick} />}

      <TextField
        placeholder="Type your message"
        value={body}
        onChange={(event) => onBodyChange(event.target.value)}
        multiline
        minRows={6}
        fullWidth
        variant="outlined"
      />

      <SegmentMeter calculation={calculation} loading={calculationLoading} />

      {body.trim().length === 0 && (
        <Box
          sx={{
            marginTop: 2,
            padding: "8px 12px",
            borderRadius: 1,
            backgroundColor: "#FEECEC",
          }}
        >
          <Typography variant="p2" color="error">
            Your message is empty — write something before you continue.
          </Typography>
        </Box>
      )}

      <Typography variant="p2" color="grey.60" component="p" mt={2}>
        Your sender number {senderNumber ?? "—"} and a one-time &quot;Reply STOP
        to opt out&quot; on the first message a person receives from you.
        Nothing to configure.
      </Typography>
    </Box>
  );
}

export default MessageEditorPanel;
